import React, { useState, useRef, useCallback, useEffect } from 'react';
import FocusTrap from 'focus-trap-react';
import { OverlayModal, DialogModal, CloseModal, HeaderModal, BodyModal, FooterModal } from './styles.js';
import { useScrollLock } from '../../hooks/useScrollLock.js';
import { CloseOutline } from '@olist/design-system-icons';
import ButtonIcon from '../ButtonIcon/ButtonIcon.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import Title from '../Text/Title/Title.js';
import Portal from '../../hooks/Portal.js';

var Modal = function (_a) {
    var title = _a.title, description = _a.description, body = _a.body, footer = _a.footer, size = _a.size, closeButtonAriaLabel = _a.closeButtonAriaLabel, isOpen = _a.isOpen, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b;
    var _c = useState(false), mounted = _c[0], setMounted = _c[1];
    var dialogRef = useRef(null);
    var overlayRef = useRef(null);
    var uniqueId = title.replace(/\s/g, '_').toLowerCase();
    var _d = useScrollLock(), lockScroll = _d.lockScroll, unlockScroll = _d.unlockScroll;
    var keypressClose = useCallback(function (e) {
        var openedModals = document.querySelectorAll('[data-modal]');
        var currentModal = openedModals[openedModals.length - 1];
        if (e.key === 'Escape' && currentModal === overlayRef.current)
            onClose();
    }, [onClose]);
    var handleClickAway = useCallback(function (event) {
        var _a, _b;
        if (!((_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) &&
            ((_b = overlayRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target))) {
            onClose();
        }
    }, [onClose]);
    useEffect(function () {
        setMounted(true);
    }, []);
    useEffect(function () {
        if (isOpen) {
            document.addEventListener('keydown', keypressClose);
            document.addEventListener('click', handleClickAway);
            lockScroll();
        }
        else {
            document.removeEventListener('keydown', keypressClose);
            document.removeEventListener('click', handleClickAway);
            unlockScroll();
        }
        return function () {
            unlockScroll();
            document.removeEventListener('keydown', keypressClose);
            document.removeEventListener('click', handleClickAway);
        };
    }, [isOpen]);
    return mounted && isOpen ? (React.createElement(Portal, { id: "modal_".concat(uniqueId) },
        React.createElement(FocusTrap, null,
            React.createElement(OverlayModal, { ref: overlayRef, "data-modal": true },
                React.createElement(DialogModal, { size: size, ref: dialogRef, "aria-labelledby": "title_".concat(uniqueId), "aria-describedby": description ? "description_".concat(uniqueId) : '', role: "dialog" },
                    React.createElement(CloseModal, null,
                        React.createElement(ButtonIcon, { "aria-label": closeButtonAriaLabel ? closeButtonAriaLabel : 'fechar modal', variation: "secondary", icon: React.createElement(CloseOutline, null), onClick: onClose })),
                    React.createElement(HeaderModal, null,
                        React.createElement(Title, { type: "default", id: "title_".concat(uniqueId) }, title),
                        description && (React.createElement(Caption, { type: "default", id: "description_".concat(uniqueId) }, description))),
                    React.createElement(BodyModal, null, body),
                    footer && React.createElement(FooterModal, null, footer)))))) : null;
};

export { Modal as default };
